<template>
  <div>
    <page-header :actions="pageActionConfig" :page="pageConfig" />
    <create-process
      v-if="showLoadProcess"
      :academic-years="academicYearsToCurrent"
      :services="services"
      @on-cancel="onCancelHandler"
      @on-save="onSaveHandler"
    />
    <div class="bg-secondary-3 rounded p-3 searchbar-custom">
      <div class="row">
        <div class="col-12 d-flex d-md-flex d-sm-block">
          <custom-drop-down
            v-model="selectedAcademicYear"
            class="w-72"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            :options="academicYears"
            placeholder="Seleccione Año Académico"
          />
          <action-button
            i="fa fa-search"
            variant="success ml-3 px-n5"
            @click="onSearchHandler"
          >
            Buscar
          </action-button>
        </div>
      </div>
    </div>
    <separator
      v-if="hasResults"
      class="my-3 p-0"
      text="Resultado de Proceso de Carga"
    />

    <row
      v-for="result in results"
      :key="result.batchLoadControlId"
      :process="result"
      @on-update="onUpdateProcess"
    />
    <pagination
      v-if="results.length > 0"
      :data="pagination"
      @pagination-go-page="pageChanged"
    />
    <b-col v-if="hasSearched && !hasResults" md="12">
      <div class="alert alert-warning mt-5">
        No existen datos a ser actualizados en la corrida seleccionada.
      </div>
    </b-col>
  </div>
</template>

<script>
import PageHeader from '@/shared/components/PageHeader/PageHeader';
import ActionButton from '@/shared/components/ActionButton';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import { CreateProcess, Row } from './components';
import {
  getAllYearsForLoadProcess as _getAllYearsForLoadProcess,
  getAssistancesBatchLoad as _getAssistancesBatchLoad,
  loadProcessExist as _loadProcessExist,
} from '@/modules/shared/scholarship.api.js';
import batchServiceTypes from '@/utils/constants/batchServiceTypes.js';
import Pagination from '@/components/common/Pagination';
import { getAcademicYearsToCurrentYear as _getAcademicYearsToCurrentYear } from '@/modules/shared/academicyear.api.js';
import { saveLoadProcess as _saveLoadProcess } from '@/modules/shared/loadprocess.api.js';
import alertMixin from '@/mixins/alert.mixin';
import { updateLoadProcess as _updateLoadProcess } from '@/modules/shared/scholarship.api.js';

export default {
  name: 'MainLoadingProcess',
  components: {
    Row,
    PageHeader,
    ActionButton,
    CustomDropDown,
    CreateProcess,
    Pagination,
  },
  mixins: [alertMixin],
  data: () => ({
    showLoadProcess: false,
    selectedAcademicYear: null,
    filter: {
      academicYear: null,
    },
    academicYears: [],
    pagination: {
      currentPage: 1,
      count: 0,
      totalItemCount: 0,
      pageCount: 1,
    },
    academicYearsToCurrent: [],
    results: [],
    hasSearched: false,
    processList: [],
  }),
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-book',
        title: 'Proceso de Carga',
        routes: ['Inicio', 'Becas', 'Proceso de Carga'],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: this.onAddHandler,
          visible: this.userHasPermissions('scholarship.loadingprocess.add'),
          class: 'mt-4',
        },
      ];
    },
    services() {
      return [
        { id: batchServiceTypes.Educativo, name: 'Educativo' },
        { id: batchServiceTypes.Terapia, name: 'Terapia' },
      ];
    },
    hasResults() {
      return this.results.length;
    },
  },

  mounted() {
    this.callGetInitFilters();
  },
  methods: {
    async callGetInitFilters() {
      const { data } = await _getAllYearsForLoadProcess();
      this.academicYears = data;
      this.selectedAcademicYear = data[0];

      this.filter = {
        ...this.filter,
        academicYear: data[0],
      };

      let years = await _getAcademicYearsToCurrentYear();
      this.academicYearsToCurrent = years.data;
    },
    async onChangeAcademicYear() {
      const academicYearId = this.filter.academicYear?.id;

      if (!academicYearId) return;
    },
    async onSearchHandler(value) {
      if (value == undefined) {
        value = 1;
        this.pagination.currentPage = 1;
      }
      let filter = {
        AcademicYearId: this.selectedAcademicYear.id,
        pageSize: 10,
        pageIndex: value,
      };

      const { data } = await _getAssistancesBatchLoad(filter);
      this.results = data.data;

      this.pagination = { ...this.pagination, ...data };
    },
    onAddHandler() {
      this.showLoadProcess = true;
    },

    pageChanged(page) {
      this.onSearchHandler(page);
      this.pagination.currentPage = page;
    },

    onCancelHandler() {
      this.showLoadProcess = false;
    },
    async onSaveHandler(model) {
      const { data } = await _loadProcessExist();
      if (data) {
        this.ShowToast(
          '',
          'Al momento existe una carga de asistencia en proceso, favor de intentar mas tarde.',
          'error'
        );
        return;
      }

      const params = {
        ...model,
        academicYearId: model.academicYear?.id,
        batchLoadServiceId: model.service?.id,
      };

      _saveLoadProcess(params)
        .then(async () => {
          this.ShowToast('', 'La carga fue creada exitosamente.', 'success');
          this.callGetInitFilters().then(async () => {
            this.onSearchHandler();
          });
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
      this.showLoadProcess = false;
    },
    async onUpdateProcess(model) {
      if (model.studentSieId == null) {
        const { data } = await _loadProcessExist();
        if (data) {
          this.ShowToast(
            '',
            'Al momento existe una carga de asistencia en proceso, favor de intentar mas tarde.',
            'error'
          );
          return;
        }
      }

      const params = {
        batchLoadControlId: model.batchLoadControlId,
        studentSieId: parseInt(model.studentSieId),
        isUpdateFlag: true,
      };

      let answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea actualizar la carga previamente ejecutada para el estudiante?',
        'Sí',
        'No'
      );

      if (answer) {
        await _updateLoadProcess(params)
          .then(async ({ data }) => {
            if (data.returnValue == 0) {
              this.ShowToast(
                '',
                'El proceso de carga fué iniciado exitosamente.',
                'success'
              );
            } else {
              this.ShowToast(
                '',
                'El proceso de carga finalizó con error.',
                'error'
              );
            }
            this.onSearchHandler();
          })
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });
      }
    },
  },
};
</script>
<style scoped>
.searchbar-custom {
  max-width: 450px;
}
</style>
